import React, { Component, PropTypes } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Joi, Validation } from "react-validation-decorator";

import SessionActions from "../../../actions/SessionActions";
import AccountActions from "../../../actions/AccountActions";
import "./SignInForm.less";
import { clearTimeout } from "timers";

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this._handleSubmit = this._handleSubmit.bind(this);
    this.isFocused = false;
  }

  validationSchema = Joi.object().keys({
    email: Joi.string().email().lowercase().required().label("Email"),
    password: Joi.string().min(8).max(30).required().label("Password"),
    agreeToPolicy: Joi.boolean().required().invalid(false),
  });

  onInputFocus() {
    if (!this.state.isFocused) {
      this.setState({ isFocused: true });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      if (!this.state.isFocused) {
        this.props._handleModalHandler("loginModal", false);
      }
    }, 5000);
  }

  render() {
    return (
      <div className="info-box-large round-corner clearfix h-100p">
        <div className="titleBox">
          <a
            href="javascript:void(0)"
            className="pull-right text-muted h4 m0 py5"
            onClick={() => {
              this.props._handleModalHandler("loginModal", false);
            }}
          >
            X
          </a>
          <h4 className="title m0 py5">Login</h4>
        </div>
        <div className="col-sm-12 mt20 mb20">
          <form name="signInFrm" noValidate>
            <Row>
              <Col md={12}>
                <div className={this.getValidationClassName("email")}>
                  <label>Email</label>
                  <input
                    onFocus={(event) => {
                      event.stopPropagation();
                      this.onInputFocus();
                    }}
                    type="email"
                    className="form-control"
                    value={this.state.email}
                    placeholder="Enter Email..."
                    onChange={this._handleInputChange.bind(this, "email")}
                  />
                  {this.renderValidationMessages("email")}
                </div>
              </Col>
              <Col xs={12}>
                <div className={this.getValidationClassName("password")}>
                  <label>Password</label>
                  <input
                    onFocus={(event) => {
                      event.stopPropagation();
                      this.onInputFocus();
                    }}
                    type="password"
                    className="form-control"
                    value={this.state.password}
                    placeholder="Enter Password..."
                    onChange={this._handleInputChange.bind(this, "password")}
                  />
                  {this.renderValidationMessages("password")}
                  <a
                    className="pull-right"
                    style={{ cursor: "pointer" }}
                    onClick={SignInForm._handleOpenForgotPasswordPopup}
                  >
                    Forgot Password?
                  </a>
                </div>
              </Col>
              <Col xs={12} className="pull-right">
                <div className="checkbox">
                  <label style={{ fontWeight: "normal" }}>
                    <input
                      type="checkbox"
                      value={this.state.agreeToPolicy}
                      onChange={this._handleInputChange.bind(
                        this,
                        "agreeToPolicy"
                      )}
                    />{" "}
                    I agree to the{" "}
                    <a
                      href="https://mentorstudents.org/terms-and-conditions"
                      target="_blank"
                    >
                      Terms of Use
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://mentorstudents.org/privacy-policy"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </label>
                </div>
                <div className="mt5">
                  <Button
                    type="submit"
                    bsStyle="success"
                    disabled={!!this.state.validation.errors.length}
                    onClick={this._handleSubmit}
                  >
                    Log In
                  </Button>
                  <a
                    href="javascript:void(0);"
                    className="ml10"
                    onClick={() => this.props.toggleModal()}
                  >
                    Sign up
                  </a>
                </div>
              </Col>
              <div className="col-xs-12 mt20">
                <div>
                  <button type="button" className="login-with-google-btn">
                    Sign in with Google
                  </button>
                </div>
                <div>
                  <a
                    className="btn btn-primary facebook-icon col-xs-12 mt10"
                    href="/api/auth/facebook"
                  >
                    Sign In with Facebook
                  </a>
                </div>
              </div>
            </Row>
          </form>
        </div>
      </div>
    );
  }

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    if (formInput === "agreeToPolicy") {
      value = !this.state["agreeToPolicy"];
    }
    this.setState(
      (state) => {
        state[formInput] = value;
      },
      () => {
        this.validate(formInput);
      }
    );
  }

  _handleSubmit(e) {
    e.preventDefault();
    const user = this.state.validation.value;
    delete user["agreeToPolicy"];
    delete user["isFocused"];
    SessionActions.signIn(user);
  }

  static _handleOpenForgotPasswordPopup() {
    SessionActions.closeSignInPopup();
    AccountActions.openForgotPasswordPopup();
  }
}

export default Validation(SignInForm);
